import { connect } from 'react-redux'

import { doUploadFiles } from 'actions/attachments'

import {
  selectDraftIdByTicketId,
  selectDraftPropByDraftId,
  makeDraftPropOrDefaultSelector,
} from 'ducks/drafts2/selectors'
import { doRealtimeAgentStartTicketTypingNotification } from 'actions/realtime'
import {
  debouncedHandleDraftChange,
  handleDraftChange,
  doDeleteDraft,
  doSendReplyDraft,
  doChangeToForward,
  doChangeToReply,
  doEnsureDefaults,
  doSwitchToDirectReply,
  doSwitchToReplyAll,
} from 'ducks/drafts2/operations'
import {
  selectIsForwarding,
  selectIsReplyHeaderExpandedInProps,
} from 'selectors/page'

import { getAssignmentLabel } from 'components/App/DesktopView/CommunicationForms/shared/util'
import { emptyArr } from 'util/arrays'
import { selectPrefersExpandedReplyHeader } from 'selectors/app'
import { selectRawTicket } from 'selectors/tickets/byId'

import View from './view'

const select = () => {
  return (state, props) => {
    const { ticketId } = props
    const ticket = selectRawTicket(state, ticketId)
    const draftId = selectDraftIdByTicketId(state, ticketId, 'reply')

    const selectDraftPropByName = makeDraftPropOrDefaultSelector(
      state,
      draftId,
      ticketId
    )

    const assigneeId = selectDraftPropByName('assigneeId')
    const assigneeGroupId = selectDraftPropByName('assigneeGroupId')
    const serverVersion = selectDraftPropByName('serverVersion')
    const version = selectDraftPropByName('version')

    const initialExpandedVisible =
      selectPrefersExpandedReplyHeader(state) ||
      selectIsReplyHeaderExpandedInProps(state)

    const isForwardingFromDraft = selectDraftPropByName('isForwarding')
    const isForwardingFromQuery = selectIsForwarding(state)

    return {
      draftId,
      defaultsSet: selectDraftPropByDraftId(state, draftId, 'defaultsSet'),
      defaultsAvailable: !!ticket.draftDefaults,
      syncable: !!draftId,
      isOpen: ticket.isOpen,
      isSynced: serverVersion === version,
      initialExpandedVisible,
      assignmentLabel: getAssignmentLabel(state, assigneeId, assigneeGroupId),
      assigneeGroupId,
      mailboxId: selectDraftPropByName('mailboxId'),
      to: selectDraftPropByName('to') || emptyArr,
      cc: selectDraftPropByName('cc') || emptyArr,
      bcc: selectDraftPropByName('bcc') || emptyArr,
      subject: selectDraftPropByName('title') || ticket.title,
      isForwardingFromDraft,
      isForwardingFromQuery,
      forwarding:
        isForwardingFromDraft === undefined
          ? isForwardingFromQuery
          : isForwardingFromDraft,
      replyType: selectDraftPropByName('replyType') || 'reply-all',
      isSendable: selectDraftPropByName('isSendable'),
      notSendableReason: selectDraftPropByName('notSendableReason'),
    }
  }
}

const perform = dispatch => {
  return {
    deleteDraft: (ticketId, draftId) => {
      if (!draftId) return
      const msg = 'Are you sure you want to delete this draft?'
      if (!window.confirm(msg)) return // eslint-disable-line no-alert

      dispatch(doDeleteDraft(ticketId, draftId))
    },
    debouncedHandleDraftChange: (ticketId, prop, val, opts) => {
      const fields = { [prop]: val }
      const { draftId } = opts
      const messageId = null // not used yet
      debouncedHandleDraftChange(
        dispatch,
        'reply',
        draftId,
        ticketId,
        messageId,
        fields
      )
    },
    handleDraftChange: (ticketId, prop, val, opts) => {
      const fields = { [prop]: val }
      const { draftId } = opts
      const messageId = null // not used yet
      handleDraftChange(dispatch, 'reply', draftId, ticketId, messageId, fields)
    },
    handleDraftMultiChange: (ticketId, fields, opts) => {
      const { draftId } = opts
      const messageId = null // not used yet
      handleDraftChange(dispatch, 'reply', draftId, ticketId, messageId, fields)
    },
    sendDraft: draftId => {
      dispatch(doSendReplyDraft(draftId))
    },
    uploadFiles: (...args) => {
      dispatch(doUploadFiles(...args))
    },
    doRealtimeAgentStartTicketTypingNotification: (...args) => {
      dispatch(doRealtimeAgentStartTicketTypingNotification(...args))
    },
    doSwitchToDirectReply: (ticketId, draftId) => {
      dispatch(doSwitchToDirectReply(ticketId, 'reply', draftId))
    },
    doSwitchToReplyAll: (ticketId, draftId) => {
      dispatch(doSwitchToReplyAll(ticketId, 'reply', draftId))
    },
    handleChangeToReply: (ticketId, draftId) => {
      dispatch(doChangeToReply(ticketId, 'reply', draftId))
    },
    handleChangeToForward: (ticketId, draftId) => {
      dispatch(doChangeToForward(ticketId, 'reply', draftId))
    },
    doEnsureDefaults: (draftId, forwarding) => {
      dispatch(doEnsureDefaults(draftId, 'reply', forwarding))
    },
  }
}

export default connect(select, perform)(View)
